module.exports = __webpack_public_path__ + "static/media/lyfestyle_3.9f19df44.png";